import React, { useState, useEffect, useRef } from "react";
import BedIcon from "@mui/icons-material/Bed";
import TodayIcon from "@mui/icons-material/Today";
import SensorDoorIcon from "@mui/icons-material/SensorDoor";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Dropdown from "./DropDown";
import DateRangePicker from "./DateRangePicker";
import SearchBox from "./searchBox";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { fetchSearchResults, setSearchCriteria } from "../redux/slices/search";
import { getDayDifference } from "../utils/utils";
import axios from "axios";
import TextBox from "./textbox";
import { createOccupancies, formatDateToEEE_MM_d } from "../utils/utils.jsx";
import { toast } from "react-toastify";
import CurrencyDropdown from "./NewDropDown/currencyDropdown.jsx";
import LanguageIcon from "@mui/icons-material/Language";
import { setSelectedCurrency } from "../redux/slices/currency";
const Search = ({ loc, dates, occupancies, tripId, open, url, hotelname }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(open || false);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const filterref = useRef(null);
  const [addAdultsPop, setAddAdultsPop] = useState(false);
  const [selectedItem, setSelectedItem] = useState(loc);
  const [dateRange, setDateRange] = useState(dates);
  const [occupancySelector, setOccupancySelector] = useState(occupancies);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const { currencies, selectedCurrency, loading } = useSelector(
    (state) => state.currency
  );

  const getLocationbasedonId = () => {
    axios
      .get(
        process.env.REACT_APP_BACKEND_ZENTRUM +
          `getlocationdetails?locationId=${loc}`
      )
      .then((resp) => {
        setSelectedItem(resp.data);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getLocationbasedonId();
    const handleClickOutside = (event, ref) => {
      if (filterref.current && !filterref.current.contains(event.target)) {
        setIsOpenFilter(false); // Close the div if clicking outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handleToggle = (val) => {
    if (val === "search") {
      setIsOpen(!isOpen);
    }
    if (val === "filter") {
      setIsOpenFilter(!isOpenFilter);
    }
  };

  const handleSelection = (item) => {
    setSelectedItem(item);
  };
  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };

  const getHotelsResults = () => {
    if (url?.pathname === "/hotel") {
      const queryParams = new URLSearchParams(url.search);
      navigate(
        `/hotel?${
          tripId ? `tid=${JSON.stringify(tripId)}&` : ""
        }locid=${queryParams.get("locid")}&hid=${queryParams.get(
          "hid"
        )}&checkin=${JSON.stringify(
          format(new Date(dateRange[0].startDate), "yyyy-MM-dd")
        )}&checkout=${JSON.stringify(
          format(new Date(dateRange[0].endDate), "yyyy-MM-dd")
        )}&oc=${JSON.stringify(occupancySelector)}&currency=${
          selectedCurrency?.code
        }&ds=${true}`
      );
      setIsOpen(false);
    } else {
      if (selectedItem && selectedItem?.id && dateRange[0].startDate) {
        navigate(
          `/search-list?${
            tripId ? `tid=${JSON.stringify(tripId)}&` : ""
          }locid=${JSON.stringify(selectedItem.id)}&checkin=${JSON.stringify(
            format(new Date(dateRange[0].startDate), "yyyy-MM-dd")
          )}&checkout=${JSON.stringify(
            format(new Date(dateRange[0].endDate), "yyyy-MM-dd")
          )}&occupancy=${JSON.stringify(occupancySelector)} &currency=${
            selectedCurrency?.code
          }`
        );

        const childages = occupancySelector?.children.map((child) => child.age);
        const oc = createOccupancies(
          occupancySelector?.rooms,
          occupancySelector?.adults,
          childages
        );
        const searchData = {
          tripId: tripId,
          locationId: selectedItem?.id,
          currency: "USD",
          checkIn: format(new Date(dateRange[0].startDate), "yyyy-MM-dd"),
          checkOut: format(new Date(dateRange[0].endDate), "yyyy-MM-dd"),
          culture: "en-us",
          nationality: "US",
          countryOfResidence: "US",
          occupancies: oc,
          contentFields: ["Basic"],
        };
        dispatch(setSearchCriteria(null));
        dispatch(fetchSearchResults({ searchData: searchData }));
        setIsOpen(false);
      } else {
        if (!selectedItem?.id) {
          toast.error("Select hotel or locations");
        } else if (!dateRange[0].startDate && !dateRange[0].endDate) {
          toast.error("Select dates");
        }
      }
    }
  };
  const changeOccupancySelection = (type, delta) => {
    setOccupancySelector((prev) => {
      const updatedValue = Math.max(
        type === "children" ? 0 : 1,
        prev[type] + delta
      );

      if (type === "children") {
        // Handle children-specific logic
        const updatedChildren = [...prev.children];
        if (delta > 0) {
          // Add new child with default age
          updatedChildren.push({ child: updatedChildren.length + 1, age: "" });
        } else if (delta < 0 && updatedChildren.length > 0) {
          // Remove the last child
          updatedChildren.pop();
        }

        return {
          ...prev,
          children: updatedChildren,
        };
      }

      return {
        ...prev,
        [type]: updatedValue,
      };
    });
  };

  const handleCurrencyChange = (val) => {
    const params = new URLSearchParams(window.location.search);

    params.set("currency", val?.code);

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, "", newUrl);
    dispatch(setSelectedCurrency(val));
  };
  return (
    <div>
      <div
        className="d-flex align-items-center justify-content-between schbar-first-cont d-hide-sl "
        onClick={() => handleToggle("search")}
        style={{
          cursor: "pointer",
          gap: 5,
        }}
      >
        <div
          className="d-flex align-items-center  "
          style={{ gap: 20, overflowX: "auto" }}
        >
          {url?.pathname === "/hotel" ? (
            <p className="pile">{hotelname}</p>
          ) : (
            <p className=" pile">
              {selectedItem?.name !== "" &&
              selectedItem?.name !== null &&
              selectedItem?.name !== undefined
                ? selectedItem?.name
                : "Search Hotels"}
            </p>
          )}
          <div className="  d-flex align-items-center  pile ">
            <TodayIcon className="sch-icon" />
            <p className="ms-2">
              {dateRange[0]?.startDate && dateRange[0]?.endDate ? (
                <>
                  {format(dateRange[0].startDate, "EEE MMM d")} -
                  {format(dateRange[0].endDate, "EEE MMM d")}
                </>
              ) : (
                "Select dates"
              )}
            </p>
          </div>
          <div className="d-flex align-items-center   pile">
            <BedIcon className="sch-icon" />{" "}
            <p className="ms-2">
              {" "}
              {getDayDifference(
                dateRange[0].startDate,
                dateRange[0].endDate
              )}{" "}
              Nights
            </p>
          </div>
          <div className="d-flex align-items-center pile">
            {" "}
            <SensorDoorIcon className="sch-icon" />
            <p className="ms-1"> {occupancySelector?.rooms} room </p>
          </div>

          <div
            className="d-flex align-items-center c-pointer pile "
            style={{ gap: 10 }}
          >
            <p>{occupancySelector?.adults} Adults</p>
            {occupancySelector?.children !== 0 ? (
              <p>{occupancySelector?.children.length} Children</p>
            ) : (
              <></>
            )}
          </div>
        </div>
        <CurrencyDropdown
          value={selectedCurrency}
          onChange={(val) => handleCurrencyChange(val)}
          options={currencies}
          placeholder="Select Currency"
          icon={<LanguageIcon sx={{ color: "#fff" }} />}
          returnObject={true}
        />
      </div>

      {isOpen ? (
        <div className="px-3 p-2 bxShadow srchopnebox ">
          <div className="row mt-4">
            <div className="col-md-6 ">
              <div className="mt-1">
                {hotelname ? (
                  <div
                    style={{
                      border: "1px solid var(--light-grey)",
                      padding: "12px 20px",
                      borderRadius: "8px",
                      color: "var(--light-grey)",
                    }}
                    className="fw-500"
                  >
                    {hotelname}
                  </div>
                ) : (
                  <SearchBox
                    apiUrl="autosuggest"
                    onSelect={handleSelection}
                    placeholder="Search Hotels, Locations..."
                    valueKey="fullName"
                    initialValue={selectedItem}
                  />
                )}
              </div>
              <div
                className="d-flex align-items-center mt-4 mb-4"
                style={{ gap: 20 }}
              >
                <div
                  className="d-flex align-items-center c-pointer adt_btn"
                  onClick={() => setAddAdultsPop(!addAdultsPop)}
                >
                  <div
                    className="d-flex align-items-center c-pointer "
                    style={{ gap: 10 }}
                  >
                    <p>{occupancySelector?.rooms} Rooms</p>
                    <p>{occupancySelector?.adults} Adults</p>
                    {occupancySelector?.children !== 0 ? (
                      <p>{occupancySelector?.children.length} Children</p>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {!addAdultsPop && (
                  <p
                    className="d-flex align-items-center adt_btn "
                    onClick={() => setAddAdultsPop(true)}
                  >
                    + Add Traveler
                  </p>
                )}
                {addAdultsPop && (
                  <div className="sc-ad-pop ">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <p>Rooms</p>
                      </div>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: 20 }}
                      >
                        <button
                          className="btnaddremove "
                          onClick={() => changeOccupancySelection("rooms", -1)}
                        >
                          <RemoveIcon />
                        </button>
                        <p>{occupancySelector?.rooms}</p>
                        <button
                          className="btnaddremove "
                          onClick={() => changeOccupancySelection("rooms", 1)}
                        >
                          <AddIcon />
                        </button>
                      </div>
                    </div>
                    <hr className="mt-1 mb-1" />
                    <div className="d-flex align-items-center justify-content-between mt-1">
                      <div>
                        <p>Adults</p>
                        <p className="fs-8">Ages 18 and older</p>
                      </div>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: 20 }}
                      >
                        <button
                          className="btnaddremove "
                          onClick={() => changeOccupancySelection("adults", -1)}
                        >
                          <RemoveIcon />
                        </button>
                        <p>{occupancySelector?.adults}</p>
                        <button
                          className="btnaddremove "
                          onClick={() => changeOccupancySelection("adults", 1)}
                        >
                          <AddIcon />
                        </button>
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-between my-1">
                      <div>
                        <p>Children</p>
                        <p className="fs-8">requires age specification</p>
                      </div>
                      <div
                        className="d-flex align-items-center justify-content-between"
                        style={{ gap: 20 }}
                      >
                        <button
                          className="btnaddremove "
                          onClick={() =>
                            changeOccupancySelection("children", -1)
                          }
                        >
                          <RemoveIcon />
                        </button>
                        <p>{occupancySelector?.children.length}</p>
                        <button
                          className="btnaddremove "
                          onClick={() =>
                            changeOccupancySelection("children", 1)
                          }
                        >
                          <AddIcon />
                        </button>
                      </div>
                    </div>
                    {occupancySelector?.children.length !== 0 &&
                      occupancySelector?.children.map((cdata, index) => (
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="fs-8">Age of Child {index + 1}</p>
                          <div className="mt-2">
                            <TextBox
                              type="number"
                              value={cdata.age || ""}
                              onChange={(e) => {
                                const newAge = Number(e.target.value);
                                if (newAge < 0 || newAge > 12) {
                                  setError(
                                    "Age must be between 1 10 12 years."
                                  );
                                } else {
                                  setError("");
                                  setOccupancySelector((prev) => ({
                                    ...prev,
                                    children: prev.children.map((c, i) =>
                                      i === index ? { ...c, age: newAge } : c
                                    ),
                                  }));
                                }
                              }}
                              max="12"
                              min="1"
                              style={{ width: "25%", height: "10px" }}
                            />
                          </div>
                        </div>
                      ))}
                    {error && (
                      <p
                        className="t-center fs-8"
                        style={{ color: "var(--red-color)" }}
                      >
                        {error}
                      </p>
                    )}
                    <hr className="mt-1 mb-1" />
                    <div
                      className="d-flex align-items-center justify-content-end mt-4 "
                      style={{ gap: 10 }}
                    >
                      <button
                        className="btn-contained "
                        onClick={() => setAddAdultsPop(false)}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <DateRangePicker
                // style={{ left: "25%", top: "15%" }}
                fromChild={dateRange}
                onDateRangeChange={handleDateRangeChange}
              />
              <div
                className="d-flex align-items-center justify-content-end mt-4 "
                style={{ gap: 10 }}
              >
                <button
                  className="btn-outlined"
                  onClick={() => setIsOpen(false)}
                >
                  Cancel
                </button>
                <button className="btn-contained " onClick={getHotelsResults}>
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center  schbar-first-cont hide-scl-bar "
          onClick={() => handleToggle("search")}
          style={{
            cursor: "pointer",
            gap: 10,
          }}
        >
          <TextBox
            placeholder="Search Hotel , Locations"
            disabled
            value={
              url?.pathname === "/hotel"
                ? hotelname
                : selectedItem?.fullName || ""
            }
          />
          <button
            className="btn-contained "
            onClick={() => handleToggle("search")}
          >
            Search{" "}
          </button>
        </div>
      )}
    </div>
  );
};

export default Search;
